import moment from "moment";

import {
  DATETIME,
  TIME,
  VERBOSE_DATE_W_DAY,
  VERBOSE_DATETIME
} from "./dateFormats";

export const expired = date => moment(date).isBefore(moment());

export const formatStartEndTime = (startTime, endTime, date = false) => {
  if (date) {
    return (
      moment(startTime).format(DATETIME) +
      "-" +
      moment(endTime).format(TIME)
    );
  } else {
    return (
      moment(startTime).format(TIME) + "-" + moment(endTime).format(TIME)
    );
  }
};

export const dateWithDayOfWeek = (date, includeTime = false) =>
  moment(date).format(includeTime ? VERBOSE_DATETIME : VERBOSE_DATE_W_DAY);
